import { Open } from '@drift-labs/icons';
import { useDrawersStore } from '../../stores/useDrawersStore';
import { WithClassName } from 'src/utils/UtilityTypes';
import { cm } from 'src/utils/classNames';
import TextButton from '../primitives/TextButton/TextButton';

export const ListYourVaultBanner = ({ className }: WithClassName) => {
	const showDrawer = useDrawersStore((s) => s.showDrawer);

	const handleOpenListYourVaultDrawer = () => {
		showDrawer('listYourVault');
	};

	return (
		<span
			className={cm(
				'flex w-full items-center justify-center gap-x-sm bg-main-bg py-2',
				className
			)}
		>
			<span className="pointer-events-none typo-b4">
				Want to list your vault?
			</span>
			<TextButton
				onClick={handleOpenListYourVaultDrawer}
				variant="tertiary"
				rightIcon={Open}
				size="sm"
			>
				Contact Us
			</TextButton>
		</span>
	);
};
